import script from "./RecentActivitiesWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecentActivitiesWidget.vue?vue&type=script&lang=ts&setup=true"

import "./RecentActivitiesWidget.vue?vue&type=style&index=0&id=675404e9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-675404e9"]])

export default __exports__